import gql from 'graphql-tag';

export const getEvaluationsToBeCorrected = gql`
  query getEvaluationsToBeCorrected($section: String!, $catalog: String!) {
    procedures {
      evaluationsTobeCorrected(section: $section, catalog: $catalog) {
        order
        evaluationType
        evaluationName
        grade
        rectificationTeacher
        registerDate
      }
    }
  }
`;

export const RegisterRectificationOfGrade = gql`
  mutation RegisterRectificationOfGrade(
    $request: RectificationRegisterRequest!
  ) {
    registerRectificationOfGrade(request: $request) {
      error
      requestId
    }
  }
`;
